import { render } from "./SimilarRecommend.vue?vue&type=template&id=5a2b3d90&scoped=true"
import script from "./SimilarRecommend.vue?vue&type=script&lang=js"
export * from "./SimilarRecommend.vue?vue&type=script&lang=js"

import "./SimilarRecommend.vue?vue&type=style&index=0&id=5a2b3d90&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2b3d90"]])

export default __exports__